import React from "react";


// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url) => {
    if ((window as any).gtag) {
        (window as any).gtag('config', process.env.GA_TRACKING_ID, {
            page_path: url,
        });
    }
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({action, category, label, value}) => {
    if ((window as any).gtag) {
        (window as any).gtag('event', action, {
            event_category: category,
            event_label: label,
            value: value,
        });
    }
}


